import logo from '../assets/brand/the-black-div-logo.png';

export const fmtQuotationMoney = (amount, currency = 'USD') =>
  `${currency} ${Number(amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const buildQuotationHtml = ({ quotation, client, items, totals, preview = true, settings = {} }) => {
  const appSettings = settings || {};
  const currency = quotation?.currency || totals?.currency || 'USD';
  const rows = (items || []).map((item, idx) => {
    const qty = Number(item.qty || item.quantity || 1);
    const unitPrice = Number(item.unitPrice || 0);
    const details = item.details || item.descriptionText || item.serviceDetails || '';
    return `
      <tr>
        <td>${String(idx + 1).padStart(2, '0')}</td>
        <td>
          <strong>${item.description || item.name || 'Service'}</strong>
          ${details ? `<p>${String(details).replace(/\n/g, '<br/>')}</p>` : ''}
        </td>
        <td>${qty}</td>
        <td>${fmtQuotationMoney(unitPrice, currency)}</td>
        <td>${fmtQuotationMoney(qty * unitPrice, currency)}</td>
      </tr>
    `;
  }).join('');

  const subtotal = totals?.subtotal ?? (items || []).reduce((sum, item) => sum + Number(item.qty || item.quantity || 1) * Number(item.unitPrice || 0), 0);
  const taxRate = Number(totals?.taxRate || quotation?.taxRate || 0);
  const total = totals?.total ?? subtotal + (subtotal * taxRate / 100);
  const title = quotation?.quotationNumber || 'Quotation';
  const clientName = client?.companyName || quotation?.client?.companyName || '-';
  const projectTitle = (items || []).map(i => i.description || i.name).slice(0, 3).join(' + ') || 'Digital Services';
  const terms = quotation?.terms || appSettings.quotationTerms || 'This quotation is valid for the stated period. The project timeline begins after confirmation and initial payment. Any extra requests outside the listed scope may affect timeline and cost. Standard revisions are included according to the agreed scope.';
  const companyEmail = appSettings.companyEmail || 'HELLO@THEBLACKDIV.COM';
  const companyPhone = appSettings.companyPhone || '+20 11 11 53 111 8';
  const companyWebsite = appSettings.companyWebsite || 'WWW. THE BLACK DIV .COM';
  const signatureName = appSettings.signatureName || 'THANK YOU';

  return `<!doctype html>
  <html>
  <head>
    <title>${title}</title>
    <style>
      @page { size: A4; margin: 0; }
      * { box-sizing: border-box; }
      body { margin: 0; font-family: Arial, sans-serif; color: #fff; background: #000; }
      .screenbar { position: sticky; top: 0; z-index: 10; display: ${preview ? 'flex' : 'none'}; justify-content: flex-end; gap: 10px; padding: 12px 18px; background: #080808; border-bottom: 1px solid #222; }
      .screenbar button { border: 0; border-radius: 8px; padding: 9px 14px; font-weight: 800; cursor: pointer; }
      .screenbar .close { background: #181818; color: #fff; border: 1px solid #333; }
      .page { min-height: 297mm; padding: 24mm; position: relative; page-break-after: always; overflow: hidden; background: #000; }
      .page:last-child { page-break-after: auto; }
      .brand { position: absolute; top: 14mm; left: 24mm; display: flex; align-items: center; gap: 12px; color: #C6FF33; font-size: 11px; letter-spacing: .08em; font-weight: 800; }
      .brand img { width: 104px; height: auto; display: block; }
      .mark { position: absolute; top: 18mm; right: 24mm; font-size: 12px; letter-spacing: .08em; color: #aaa; }
      .cover { display: flex; flex-direction: column; justify-content: center; }
      .stripe { position: absolute; inset: 0 0 0 auto; width: 34%; background: #7D39EB; }
      .lime { color: #C6FF33; }
      h1 { font-size: 58px; line-height: .92; margin: 0 0 22px; max-width: 640px; letter-spacing: -.03em; position: relative; z-index: 1; }
      h2 { font-size: 34px; line-height: 1; margin: 0 0 18px; text-transform: uppercase; }
      .meta { display: grid; grid-template-columns: 120px 1fr; gap: 8px 20px; max-width: 620px; position: relative; z-index: 1; }
      .meta b { color: #C6FF33; text-transform: uppercase; font-size: 12px; letter-spacing: .08em; }
      .meta span { font-size: 17px; font-weight: 800; text-transform: uppercase; }
      .section-no { color: #7D39EB; font-size: 78px; font-weight: 900; line-height: 1; margin-bottom: 12px; }
      .lead { font-size: 22px; line-height: 1.35; max-width: 720px; color: #f4f4f4; }
      .panel { background: #fff; color: #000; padding: 20px; margin-top: 24px; }
      table { width: 100%; border-collapse: collapse; margin-top: 18px; color: #000; }
      th { background: #C6FF33; color: #000; text-align: left; padding: 12px; font-size: 11px; text-transform: uppercase; letter-spacing: .06em; }
      td { border-bottom: 1px solid #ddd; padding: 13px 12px; vertical-align: top; font-size: 13px; }
      td strong { display: block; font-size: 15px; margin-bottom: 5px; }
      td p { margin: 0; color: #333; line-height: 1.45; }
      .totals { margin-left: auto; margin-top: 18px; width: 330px; color: #000; font-size: 14px; }
      .totals div, .totals strong { display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #ddd; }
      .totals strong { font-size: 18px; border-bottom: 0; }
      .terms { color: #111; line-height: 1.6; font-size: 15px; }
      .cta { font-size: 46px; line-height: 1; max-width: 760px; margin-top: 72mm; }
      .footer { position: absolute; bottom: 16mm; left: 24mm; right: 24mm; display: flex; justify-content: space-between; color: #aaa; font-size: 11px; }
      @media print {
        .screenbar { display: none; }
        body { background: #000; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      }
    </style>
  </head>
  <body>
    <div class="screenbar">
      <button class="close" onclick="window.close()">Close Preview</button>
    </div>
    <section class="page cover">
      <div class="stripe"></div>
      <div class="brand"><img src="${logo}" alt="The Black Div" />${companyWebsite}</div>
      <div class="mark">WHERE GRAVITY TAKES OVER</div>
      <h1>WHERE <span class="lime">GRAVITY</span><br/>TAKES OVER</h1>
      <div class="meta">
        <b>Client</b><span>${clientName}</span>
        <b>Quotation</b><span>${title}</span>
        <b>Project</b><span>${projectTitle}</span>
        <b>Date</b><span>${quotation?.issueDate || new Date().toLocaleDateString()}</span>
      </div>
      <div class="footer"><span>${companyEmail}</span><span>${String(quotation?.status || 'draft').toUpperCase()}</span></div>
    </section>
    <section class="page">
      <div class="brand"><img src="${logo}" alt="The Black Div" />${companyWebsite}</div>
      <div class="mark">${title}</div>
      <div class="section-no">01</div>
      <h2>Executive Overview</h2>
      <p class="lead">This quotation is positioned as a strategic investment in stronger market presence, clearer positioning, and a more professional client acquisition experience.</p>
      <div class="panel">
        <h2>Scope & Investment</h2>
        <table>
          <thead><tr><th>#</th><th>Service & Details</th><th>Qty</th><th>Unit Price</th><th>Total</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
        <div class="totals">
          <div><span>Subtotal</span><span>${fmtQuotationMoney(subtotal, currency)}</span></div>
          <div><span>Tax</span><span>${taxRate}%</span></div>
          <strong><span>Total Investment</span><span>${fmtQuotationMoney(total, currency)}</span></strong>
        </div>
      </div>
      <div class="footer"><span>${title}</span><span>INVESTMENT & SCOPE</span></div>
    </section>
    <section class="page">
      <div class="brand"><img src="${logo}" alt="The Black Div" />${companyWebsite}</div>
      <div class="mark">${title}</div>
      <div class="section-no">02</div>
      <h2>Terms & Next Steps</h2>
      <div class="panel"><div class="terms">${String(terms).replace(/\n/g, '<br/>')}${quotation?.notes ? `<br/><br/><strong>Notes</strong><br/>${String(quotation.notes).replace(/\n/g, '<br/>')}` : ''}</div></div>
      <h1 class="cta">LET'S BUILD <span class="lime">SOMETHING POWERFUL</span> TOGETHER.</h1>
      <div class="footer"><span>${companyPhone}</span><span>${signatureName}</span></div>
    </section>
  </body>
  </html>`;
};

export const openQuotationPreview = (data) => {
  const w = window.open('', '_blank');
  w.document.write(buildQuotationHtml({ ...data, preview: true }));
  w.document.close();
};

export const exportQuotationPdf = async (data) => {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
    import('html2canvas'),
    import('jspdf'),
  ]);
  const html = buildQuotationHtml({ ...data, preview: false });
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.left = '-10000px';
  iframe.style.top = '0';
  iframe.style.width = '794px';
  iframe.style.height = '1123px';
  iframe.style.opacity = '0';
  document.body.appendChild(iframe);
  iframe.contentDocument.open();
  iframe.contentDocument.write(html);
  iframe.contentDocument.close();

  await new Promise(resolve => setTimeout(resolve, 700));
  const pages = Array.from(iframe.contentDocument.querySelectorAll('.page'));
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  for (let i = 0; i < pages.length; i += 1) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: '#000000',
      windowWidth: 794,
      windowHeight: 1123,
    });
    const img = canvas.toDataURL('image/jpeg', 0.95);
    if (i > 0) pdf.addPage();
    pdf.addImage(img, 'JPEG', 0, 0, 210, 297);
  }

  const filename = `${data.quotation?.quotationNumber || data.client?.companyName || 'quotation'}.pdf`
    .replace(/[\\/:*?"<>|]+/g, '-');
  pdf.save(filename);
  document.body.removeChild(iframe);
};
